import shopifyImpactGenericDefaults from '../shopify-impact-generic/config.js';

const wheelsFields = ['wheel_tire_diameter', 'wheel_width', 'wheel_bolt_pattern'];
const tiresFields = ['tire_width', 'tire_aspect', 'wheel_tire_diameter'];

const ignoreFields = [...wheelsFields, ...tiresFields];

const isOnPackagesPage = window.location.pathname === '/collections/build-a-package';

window.Convermax.mountedPackagesAddToCartWithRedirect = (productId, variantId) => async (e) => {
  e.preventDefault();
  e.stopPropagation();

  const { href } = window.location;
  const redirectPath =
    href.includes('WheelProductID') || href.includes('lastStep')
      ? '/cart'
      : isOnPackagesPage || window.location.pathname.includes('/products/')
        ? window.Convermax.getVehicleUrl(`/collections/tires/?WheelProductID/${productId}`)
        : null;

  if (!redirectPath) {
    return;
  }

  const cartUrls = window.Convermax.Shopify.getCartUrls();

  const bodyForm = {
    items: [
      {
        id: variantId,
        quantity: 4,
      },
    ],
  };

  fetch(`${cartUrls.add}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(bodyForm),
  })
    .then((response) => {
      if (response.ok) {
        window.location.replace(redirectPath);
      } else {
        // check if the cart is already contains this product
        fetch(`${cartUrls.root}.js`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.items?.some((i) => i.variant_id === +variantId)) {
              window.location.replace(redirectPath);
            } else {
              console.error(response);
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    })
    .catch((e) => {
      console.error(e);
    });
};

function onVerifyFitmentResponseReceived(response) {
  const packageButton = window.document.querySelector('#cm-package-button');

  if (!response.Items?.length || !packageButton) {
    return;
  }

  // eslint-disable-next-line camelcase
  const [{ id, variant_ids, fitsTheVehicle, hasMatchTires, FitmentType }] = response.Items;

  const isWheelOrLastStep = FitmentType.includes('Wheel') || window.location.href.includes('lastStep');
  if (!isWheelOrLastStep) {
    return;
  }

  if (fitsTheVehicle === 'yes' && hasMatchTires) {
    packageButton.style.display = 'block';
    packageButton.addEventListener('click', async (e) => {
      // eslint-disable-next-line camelcase
      window.Convermax.mountedPackagesAddToCartWithRedirect(id, variant_ids[0])(e);
    });
  } else {
    packageButton.style.display = 'none';
  }
}

export default {
  includes: ['shopify-impact-generic'],
  ...shopifyImpactGenericDefaults,
  SearchRequestDefaults: {
    ...shopifyImpactGenericDefaults.SearchRequestDefaults,
    extra: {
      ...shopifyImpactGenericDefaults.SearchRequestDefaults.extra,
      doNotHideWheelsTiresFacets: window.location.pathname === '/',
    },
  },
  fitmentSearch: {
    ...shopifyImpactGenericDefaults.fitmentSearch,
    forceVehicleSelection: isOnPackagesPage,
    onVerifyFitmentResponseReceived,
    onVerifyFitmentInitResponseReceived: onVerifyFitmentResponseReceived,
  },
  Widgets: [
    ...shopifyImpactGenericDefaults.Widgets.filter(
      (w) =>
        ![
          'WheelPanel_tab',
          'TirePanel_tab',
          'WheelTireVehicleInfo',
          'FacetBarWheels',
          'FacetBarTires',
          'FilterChips',
          'Facets',
        ].includes(w.name),
    ),
    {
      name: 'WheelPanel_tab',
      type: 'RequestPanel',
      location: '#cm-wheel-tab',
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      selectFields: wheelsFields,
    },
    {
      name: 'TirePanel_tab',
      type: 'RequestPanel',
      location: '#cm-tire-tab',
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      selectFields: tiresFields,
    },
    {
      name: 'WheelTireVehicleInfo',
      useAutoSyncVisualizer: true,
    },
    {
      name: 'UpsizeDownsizeFacetPanel',
      type: 'FacetPanel',
      fields: ['wheel_tire_diameter'],
      showAllAlways: true,
      disableCollapse: true,
    },
    {
      name: 'FacetBarWheels',
      type: 'FacetBar',
      fields: wheelsFields,
      minFacetCount: 2,
    },
    {
      name: 'FacetBarTires',
      type: 'FacetBar',
      fields: tiresFields,
      minFacetCount: 2,
    },
    {
      name: 'FilterChips',
      type: 'FacetPanel',
      ignoreFields,
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
      ignoreFields,
    },
  ],
};
